(() => {
  'use strict';
  const config = window.SevenFortyFive;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let preference = 'on';
  try { preference = localStorage.getItem('745-motion') || 'on'; } catch {}
  const enabled = () => preference !== 'off' && !reduced.matches;
  config.motion = {enabled};
  const button = document.querySelector('[data-motion-toggle]');
  function sync() {
    const active = enabled();
    document.body.classList.toggle('motion-off', !active);
    if (button) {
      button.textContent = 'Motion ' + (active ? 'on' : 'off');
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', reduced.matches ? 'Motion off. Your device requests reduced motion.' : 'Automatic motion ' + (active ? 'on. Turn off.' : 'off. Turn on.'));
      button.disabled = reduced.matches;
    }
    document.dispatchEvent(new CustomEvent('745:motionchange', {detail: {enabled: active}}));
  }
  button?.addEventListener('click', () => {
    preference = enabled() ? 'off' : 'on';
    try { localStorage.setItem('745-motion', preference); } catch {}
    sync();
  });
  reduced.addEventListener('change', sync);
  sync();
})();
